import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  // set a key/value
  async set(key: string, value: any): Promise<any> {
    try {
      //const result = await this.storage.set(key, value);
      //console.log('set string in storage: ' + result);
      localStorage.setItem(key, value);
      return true;
    } catch (reason) {
      console.log(reason);
      return false;
    }
  }
  // to get a key/value pair
  async get(key: string): Promise<any> {
    try {
      //const result = await this.storage.get(key);
      //console.log('storageGET: ' + key + ': ' + result);
      const result = await localStorage.getItem(key);
      if (result != null) {
        return result;
      }
      return null;
    } catch (reason) {
      console.log(reason);
      return null;
    }
  }
  // set a key/value object
  async setObject(key: string, object: Object) {
    try {
      //const result = await this.storage.set(key, JSON.stringify(object));
      //console.log('set Object in storage: ' + result);
      localStorage.setItem(key, JSON.stringify(object));
      return true;
    } catch (reason) {
      console.log(reason);
      return false;
    }
  }
  // get a key/value object
  async getObject(key: string): Promise<any> {
    try {
      //const result = await this.storage.get(key);
      const result = await localStorage.getItem(key);
      if (result != null) {
        return JSON.parse(result);
      }
      return null;
    } catch (reason) {
      console.log(reason);
      return null;
    }
  }
  // remove a single key value:
  remove(key: string) {
    // this.storage.remove(key);
    localStorage.removeItem(key);
  }
  //  delete all data from your application:
  clear() {
    // this.storage.clear();
    localStorage.clear();
  }
}
